import { Edge, EdgeProps } from '@/components/Edge';
import { Component } from '@/types/component';
import { cn } from 'lib/utils';
import localFonts from 'next/font/local';

// Licensed fonts, please do not change
const fontPrimary = localFonts({
  display: 'swap',
  preload: true,
  src: [
    { path: '../../../public/fonts/MasqualeroRegular_normal_normal_subset1.woff2', weight: '400', style: 'normal' },
    { path: '../../../public/fonts/MasqualeroDemiBold_normal_normal_subset1.woff2', weight: '600', style: 'normal' },
    { path: '../../../public/fonts/MasqualeroBold_normal_normal_subset1.woff2', weight: '700', style: 'normal' },
  ],
  variable: '--font-al-primary',
});

const fontSecondary = localFonts({
  display: 'swap',
  preload: true,
  src: [
    { path: '../../../public/fonts/PTSerif-normal-400.woff2', weight: '400', style: 'normal' },
    { path: '../../../public/fonts/PTSerif-normal-700.woff2', weight: '700', style: 'normal' },
  ],
  variable: '--font-al-secondary',
});

const fontTertiary = localFonts({
  display: 'swap',
  preload: true,
  src: [
    { path: '../../../public/fonts/AvenirNextRegular_normal_normal_subset1.woff2', weight: '400', style: 'normal' },
    { path: '../../../public/fonts/AvenirNextDemi_normal_normal_subset1.woff2', weight: '600', style: 'normal' },
  ],
  variable: '--font-al-tertiary',
});

const fonts = cn(fontPrimary.variable, fontSecondary.variable, fontTertiary.variable);

export const AllasEdge: Component<EdgeProps> = ({ children }) => {
  return (
    <Edge favicon="/favicon.svg" className={fonts}>
      {children}
    </Edge>
  );
};

export default AllasEdge;
